import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import * as FileSaver from 'file-saver';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { PaymentTermsModalComponent } from 'shared/modal/payment-terms/payment-terms-modal.component';
import { AppModalService } from 'shared/modal/modal.service';
import { BillingService } from 'shared/billing/billing.service';
import { SearchModel } from 'shared/search/search.model';
import { BrandService } from 'shared/brand/brand.service';
import { columns } from './columns';
import {ProductPanelComponent} from '../../../../../product-panel/product-panel.component';

@Component({
  moduleId: module.id,
  selector: 'billing-form',
  templateUrl: 'billing-form.component.html',
  styleUrls: ['billing-form.component.scss'],
})

export class BillingFormComponent extends SearchWidgetComponent implements OnInit {
  searchModel = new SearchModel();
  items: Array<any> = [];

  @Input() brandId: string;
  @Input() timezone: string;

  @ViewChild(PaymentTermsModalComponent, {static: false})
  paymentTermsModal: PaymentTermsModalComponent | void;

  constructor(
    public searchService: BillingService,
    protected brandService: BrandService,
    protected ref: ChangeDetectorRef,
    private appModalService: AppModalService,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isEmpty(): boolean {
    return this.totalRecords === 0;
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    this.initSubscriptions();
    this.initSearchModel();
    this.runSearch();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onDownloadClick(id: any) {
    // TODO: add download by real src parameter
    const item: any = _.find(this.items, {_id: id});
    this.searchService.downloadInvoice(this.brandId, item._id)
      .subscribe((res) => {
        const filename = `${item.invoice_number}.pdf`;
        FileSaver.saveAs(res, filename);
      });
  }

  onPaymentTermsClick(event: MouseEvent) {
    event.preventDefault();
    if (this.paymentTermsModal instanceof PaymentTermsModalComponent) {
      this.paymentTermsModal.show();
    }
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  runSearch() {
    this.searchService.runSearch(
      this.brandId,
      this.searchModel,
    )
    .subscribe(data => {
      this.items = data.data || [];
      this.ref.markForCheck();
    });
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private initSearchModel() {
    this.searchModel.itemsPerPage = 10;
    this.searchResultsColumns = columns;
    this.ref.markForCheck();
  }
}
